export type NumberOfWeeks = 1 | 2 | 4;

export enum WeekSubset {
  all = "all",
  workdays = "workdays",
  weekend = "weekends",
}
